import { useEffect, useState } from "react";

// ui
import { Box } from "@mui/material";

// Table
import TableTopBar from "../component/TableTopBar";
import { ConstTable } from "../component/Table";
import { EmptyState } from "../component/EmptyState";

// Bar
import { SerchSideBar } from "../component/SerchSideBar";

// Modal
import { FollowCallModal } from "../component/tableFunction/FollowCallModal";
import { FollowCallStartStopModal } from "../component/tableFunction/FollowCallStartStopModal";
import { GetXLSXFollowCallModal } from "../component/GetXLSXFollowCallModal";

// jotai
import { useAtomValue, useSetAtom } from "jotai";
import { AppAtoms } from "../lib/store";

// API
import {
  getFollowCalls,
  putFollowCallStatus,
  putFollowCallCall,
} from "../api/followCall";
import {
  getSerchHighRankCompanys,
  getSerchCategorys,
  getSerchProducts,
  getSerchSaleCompanys,
  getSerchAccountSales,
  getProductCandidatesEntry,
} from "../api/serch";

// InterFace
import { followCallTableColumn } from "../config/followCall";
import {
  dataDifine,
  subDataDifine,
  EditDataDifine,
} from "../config/dataInterface";

// OtherFunc
import { getFirstYear, getOneYear } from "../lib/other";
import { CONST } from "../config/const";

function FollowCall() {
  const setIsLoading = useSetAtom(AppAtoms.isLoading);
  const isSmartPhone = useAtomValue(AppAtoms.isSmartPhone);
  const loginUser = useAtomValue(AppAtoms.loginUser);

  // 各権限毎のヘッダーメニューの編集
  const addDataTypes: { auth: string[]; name: string }[] = [];
  const addCSVDataTypes: { auth: string[]; name: string }[] = [];
  const getXLSXDataTypes: { auth: string[]; name: string }[] = [
    {
      auth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      name: "フォローアップ一覧出力",
    },
  ];
  const editDatasTypes: { auth: string[]; name: string }[] = [];

  const [addDataNames, setAddDataNames] = useState<string[]>([]);
  const [addDataName, setAddDataName] = useState<string>("");
  const [addCSVDataNames, setAddCSVDataNames] = useState<string[]>([]);
  const [addCSVDataName, setAddCSVDataName] = useState<string>("");
  const [getXLSXDataNames, setGetXLSXDataNames] = useState<string[]>([]);
  const [getXLSXDataName, setGetXLSXDataName] = useState<string>("");
  const [editDatasNames, setEditDatasNames] = useState<string[]>([]);
  const [editDatasName, setEditDatasName] = useState<string>("");

  useEffect(() => {
    let addDataNames: string[] = [];
    let addCSVDataNames: string[] = [];
    let getXLSXDataNames: string[] = [];
    let editDatasNames: string[] = [];
    addDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority,
        ) > -1
      ) {
        addDataNames.push(dataType.name);
      }
    });
    setAddDataNames(addDataNames);
    addCSVDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority,
        ) > -1
      ) {
        addCSVDataNames.push(dataType.name);
      }
    });
    setAddCSVDataNames(addCSVDataNames);
    getXLSXDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority,
        ) > -1
      ) {
        getXLSXDataNames.push(dataType.name);
      }
    });
    setGetXLSXDataNames(getXLSXDataNames);
    editDatasTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority,
        ) > -1
      ) {
        editDatasNames.push(dataType.name);
      }
    });
    setEditDatasNames(editDatasNames);
  }, [loginUser]);

  useEffect(() => {}, [addDataName]);

  useEffect(() => {}, [addCSVDataName]);

  useEffect(() => {
    if (getXLSXDataName === "フォローアップ一覧出力") {
      setGetXLSXStatus({
        ...getXLSXStatus,
        status: "open",
      });
    }
  }, [getXLSXDataName]);

  // サブテーブルデータの一覧取得
  const [getSubTableName, setGetSubTableName] = useState<{
    name: string;
    key: { [key: string]: string };
    subData: subDataDifine[];
  }>({
    name: "",
    key: {},
    subData: [],
  });
  useEffect(() => {}, [getSubTableName.name, getSubTableName.key]);

  // サブテーブルデータの詳細取得
  const [getSubTableDetail, setGetSubTableDetail] = useState<{
    name: string;
    key: { [key: string]: string };
    dataDetail: {
      [key: string]:
        | number
        | string
        | { [key: string]: string | number }[]
        | { [key: string]: string | string[] };
    } | null;
  }>({
    name: "",
    key: {},
    dataDetail: null,
  });
  useEffect(() => {}, [getSubTableDetail.name, getSubTableDetail.key]);

  // サブテーブルデータの登録
  const [getSubTableAdd, setGetSubTableAdd] = useState<{
    name: string;
    row: dataDifine | null;
  }>({
    name: "",
    row: null,
  });
  useEffect(() => {}, [getSubTableAdd.name, getSubTableAdd.row]);

  // サブサブテーブルデータの一覧取得
  const [getSubSubTableName, setGetSubSubTableName] = useState<{
    name: string;
    key: { [key: string]: string };
    subData: subDataDifine[];
  }>({
    name: "",
    key: {},
    subData: [],
  });
  useEffect(() => {}, [getSubSubTableName.name, getSubSubTableName.key]);

  // サブテーブルデータの登録
  const [getSubSubTableAdd, setGetSubSubTableAdd] = useState<{
    name: string;
    row: dataDifine | null;
  }>({
    name: "",
    row: null,
  });
  useEffect(() => {}, [getSubSubTableAdd.name, getSubSubTableAdd.row]);

  const [tableOriginalFunc, setTableOriginalFunc] = useState<{
    name: string;
    key: { [key: string]: string };
  }>({
    name: "",
    key: {},
  });
  useEffect(() => {
    if (tableOriginalFunc.name === "停止・再開") {
      setStartStopDataInf({
        status: "open",
        key: tableOriginalFunc.key,
        message: "",
      });
    }
    if (tableOriginalFunc.name === "フォローコール") {
      setCallDataInf({
        ...callDataInf,
        status: "open",
        key: tableOriginalFunc.key,
        follow_call_hope_time:
          tableOriginalFunc.key.follow_call_hope_time === "-"
            ? ""
            : tableOriginalFunc.key.follow_call_hope_time,
        follow_call_memo:
          tableOriginalFunc.key.follow_call_memo === "-"
            ? ""
            : tableOriginalFunc.key.follow_call_memo,
      });
    }
  }, [tableOriginalFunc.name, tableOriginalFunc.key]);

  const [serchOpen, setSerchOpen] = useState(false);
  const aiChatOpen = useAtomValue(AppAtoms.aiChatOpen);
  const setAiChatOpenAtom = useSetAtom(AppAtoms.aiChatOpen);
  // cmd-po_1168 SP排他: AI open時に検索を close
  useEffect(() => {
    if (aiChatOpen && isSmartPhone) setSerchOpen(false);
  }, [aiChatOpen, isSmartPhone]);
  const handleSetSerchOpen = (open: boolean) => {
    setSerchOpen(open);
    if (open && isSmartPhone) setAiChatOpenAtom(false);
  };

  const firstYear = getFirstYear();
  const { thisYear, thisMonth, lastYear, lastMonth } = getOneYear();

  // 表示数・ページ
  const [displayNumber, setDisplayNumber] = useState(50);
  const displayNumbers = [25, 50, 100, 250, 500];
  const [pageNumber, setPageNumber] = useState(1);
  const [maxPageNumber, setMaxPageNumber] = useState(1);

  // 検索項目
  const serchColumn = followCallTableColumn.dataColumn.reduce(
    (column, difine) => {
      if (difine.serch === true) {
        if (difine.serchType === "date") {
          return {
            ...column,
            [difine.key + "_start"]: "",
            [difine.key + "_end"]: "",
          };
        } else {
          return {
            ...column,
            [difine.key]: "",
          };
        }
      } else {
        return {
          ...column,
        };
      }
    },
    {},
  );
  const [serchString, setSerchString] = useState(serchColumn);
  const [serchStringView, setSerchStringView] = useState(serchColumn);

  // ソート項目
  const [sortColumn, setSortColumn] = useState<
    {
      key: string;
      sort: string;
    }[]
  >(
    followCallTableColumn.dataColumn
      .filter((column) => {
        return column.sort;
      })
      .map((column) => {
        return {
          key: column.key,
          sort: "DESC",
        };
      }),
  );

  // テーブルデータ
  const [fetchData, setFetchData] = useState<dataDifine[]>([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  async function getTableData(edit: boolean) {
    if (!edit) {
      setIsLoading(true);
    }
    const fetchData = await getFollowCalls(
      {
        ...serchString,
        displayNumber,
        pageNumber,
      },
      sortColumn,
    );
    if (fetchData === null) {
      setFetchData([]);
      setTotalCount(0);
      setMaxPageNumber(1);
      setPageNumber(1);
    } else if (fetchData) {
      setFetchData(fetchData.followCalls);
      const countFollowCalls = Number(fetchData.countFollowCalls);
      setTotalCount(countFollowCalls);
      setMaxPageNumber(Math.ceil(countFollowCalls / displayNumber));
    }
    if (!edit) {
      setIsLoading(false);
    }
  }
  useEffect(() => {
    getTableData(false);
  }, [serchString, displayNumber, pageNumber, sortColumn]);

  // フォローコール停止・再開
  const [startStopDataInf, setStartStopDataInf] = useState<{
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
  }>({
    status: null,
    key: {},
    message: "",
  });
  async function startStopData() {
    setStartStopDataInf({
      ...startStopDataInf,
      status: "loading",
    });
    const id = startStopDataInf.key.id;
    const startStop = startStopDataInf.key.startStop;
    const responce = await putFollowCallStatus(id, startStop);
    if (responce == "success") {
      await getTableData(false);
      setStartStopDataInf({
        ...startStopDataInf,
        status: "success",
      });
    } else {
      setStartStopDataInf({
        ...startStopDataInf,
        status: "failed",
        message: responce,
      });
    }
  }
  useEffect(() => {
    if (startStopDataInf.status === "loading") {
      setIsLoading(true);
    } else if (startStopDataInf.status !== null) {
      setIsLoading(false);
    }
  }, [startStopDataInf.status]);

  // フォローコール
  const [callDataInf, setCallDataInf] = useState<{
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
    follow_call_status: number | null;
    follow_call_hope_date: string;
    follow_call_hope_time: string;
    follow_call_memo: string;
  }>({
    status: null,
    key: {},
    message: "",
    follow_call_status: null,
    follow_call_hope_date: "",
    follow_call_hope_time: "",
    follow_call_memo: "",
  });
  async function callData() {
    setCallDataInf({
      ...callDataInf,
      status: "loading",
    });
    const id = callDataInf.key.id;
    const responce = await putFollowCallCall(
      id,
      callDataInf.follow_call_status,
      callDataInf.follow_call_hope_date,
      callDataInf.follow_call_hope_time,
      callDataInf.follow_call_memo,
    );
    if (responce == "success") {
      await getTableData(false);
      setCallDataInf({
        ...callDataInf,
        status: "success",
      });
    } else {
      setCallDataInf({
        ...callDataInf,
        status: "failed",
        message: responce,
      });
    }
  }
  useEffect(() => {
    if (callDataInf.status === "loading") {
      setIsLoading(true);
    } else if (callDataInf.status !== null) {
      setIsLoading(false);
    }
  }, [callDataInf]);

  // 明細Excel取得
  // cmd-po_1397: データ系facet退役=状態はstatus+messageのみ
  const [getXLSXStatus, setGetXLSXStatus] = useState<{
    status: "none" | "open" | "getting" | "result" | "loading" | "error";
    message: string;
    merge_sheet: boolean;
  }>({
    status: "none",
    message: "",
    merge_sheet: false,
  });

  async function getPaymentsXLSX() {
    const idToken = loginUser?.idToken;
    // cmd-po_1397: データ系facet退役=fileName固定値
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // 月は0始まりのため+1
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const nowTimeName = `${year}${month}${day}_${hours}${minutes}${seconds}`;
    const fileName = "フォローコール一覧_" + nowTimeName + ".xlsx";
    const bodys = {
      type: "get_xlsx_follow_call",
      sale_company_id: null,
      sale_company_name: "",
      all_company: true,
      product_id: null,
      product_name: "",
      all_product: true,
      search_params: serchString,
      merge_sheet: getXLSXStatus.merge_sheet,
      idToken,
      fileName,
    };
    // WebSocketオブジェクトを生成しサーバとの接続を開始
    const url =
      CONST.outputXLSXFollowCallsWebSocketAPIURL + "?Authorization=" + idToken;
    const websocket = new WebSocket(url);
    let succeeded = false;
    let noProgressTimer: ReturnType<typeof setTimeout> | null = null;
    const clearNoProgressTimer = () => {
      if (noProgressTimer) { clearTimeout(noProgressTimer); noProgressTimer = null; }
    };
    const failXLSX = () => {
      if (succeeded) return;
      clearNoProgressTimer();
      setGetXLSXStatus({
        ...getXLSXStatus,
        status: "error",
        message: "出力に失敗しました。再度お試しください",
      });
      if (websocket.readyState === WebSocket.OPEN) websocket.close();
    };
    const armNoProgressTimer = () => {
      clearNoProgressTimer();
      noProgressTimer = setTimeout(failXLSX, 3 * 60 * 1000);
    };
    // メッセージ受信時のイベントハンドラを設定
    const onMessage = async (event_websocket: any) => {
      armNoProgressTimer();
      const decodedData = JSON.parse(event_websocket.data);
      if (decodedData.message === "success") {
        succeeded = true;
        clearNoProgressTimer();
        const url = decodedData.url;
        const link = document.createElement("a");
        link.href = decodedData.url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(url);
        link.parentNode?.removeChild(link);

        setGetXLSXStatus({
          ...getXLSXStatus,
          status: "result",
          message: "",
        });
        websocket.close();
      } else if (
        decodedData.message !== "End_WebSocket_API" &&
        decodedData.message !== "Endpoint request timed out"
      ) {
        setGetXLSXStatus({
          ...getXLSXStatus,
          status: "getting",
          message: decodedData.message,
        });
      }
    };
    websocket.onmessage = onMessage;
    websocket.onopen = () => { armNoProgressTimer(); websocket.send(JSON.stringify(bodys)); };
    websocket.onclose = failXLSX;
  }

  // 上位店一覧
  const [highRankCompanyList, setHighRankCompanyList] = useState<
    { id: number; high_rank_company_name: string }[]
  >([]);
  const [highRankCompanyNameList, setHighRankCompanyNameList] = useState([""]);
  // 上位店一覧取得
  async function getHighRankCompanyList() {
    const fetchData = await getSerchHighRankCompanys();
    if (fetchData === null) {
      setHighRankCompanyList([]);
    } else if (fetchData) {
      setHighRankCompanyList(
        fetchData.highRankCompanys as {
          id: number;
          high_rank_company_name: string;
        }[],
      );
      let highRankCompanyNameList = [""];
      fetchData.highRankCompanys.map(
        (company: { id: number; high_rank_company_name: string }) => {
          if (
            !highRankCompanyNameList.includes(company.high_rank_company_name)
          ) {
            highRankCompanyNameList.push(company.high_rank_company_name);
          }
        },
      );
      setHighRankCompanyNameList(highRankCompanyNameList);
    }
  }

  // カテゴリ一覧
  const [categoryList, setCategoryList] = useState<
    { id: number; category_name: string }[]
  >([]);
  const [categoryNameList, setCategoryNameList] = useState([""]);
  async function getCategoryList() {
    const fetchData = await getSerchCategorys();
    if (fetchData === null) {
      setCategoryList([]);
    } else if (fetchData) {
      setCategoryList(
        fetchData.categorys as {
          id: number;
          category_name: string;
        }[],
      );
      let categoryNameList = [""];
      fetchData.categorys.map(
        (company: { id: number; category_name: string }) => {
          if (!categoryNameList.includes(company.category_name)) {
            categoryNameList.push(company.category_name);
          }
        },
      );
      setCategoryNameList(categoryNameList);
    }
  }

  // パートナー一覧
  const [companyList, setCampanyList] = useState<
    { id: number; sale_company_name: string }[]
  >([]);
  const [companyNameList, setCampanyNameList] = useState([""]);
  // パートナー一覧取得
  async function getSaleCompanysList() {
    const fetchData = await getSerchSaleCompanys();
    if (fetchData === null) {
      setCampanyList([]);
    } else if (fetchData) {
      setCampanyList(
        fetchData.saleCompanys as { id: number; sale_company_name: string }[],
      );
      let companyNameList = [""];
      fetchData.saleCompanys.map(
        (company: { id: number; sale_company_name: string }) => {
          if (!companyNameList.includes(company.sale_company_name)) {
            companyNameList.push(company.sale_company_name);
          }
        },
      );
      setCampanyNameList(companyNameList);
    }
  }

  // 商材一覧
  const [productList, setProductList] = useState<
    {
      id: number;
      high_rank_company_id: number;
      product_name: string;
      high_rank_company_name: string;
      product_key: string;
    }[]
  >([]);
  const [productNameList, setProductNameList] = useState([""]);
  async function getProductList() {
    const fetchData = await getSerchProducts();
    if (fetchData === null) {
      setProductList([]);
    } else if (fetchData) {
      setProductList(
        fetchData.products as {
          id: number;
          high_rank_company_id: number;
          product_name: string;
          high_rank_company_name: string;
          product_key: string;
        }[],
      );
    }
  }
  async function getProductNameListFromHistory() {
    const products = await getProductCandidatesEntry();
    if (products) {
      const names: string[] = [""];
      for (const p of products) {
        if (p.product_name && !names.includes(p.product_name)) {
          names.push(p.product_name);
        }
      }
      setProductNameList(names);
    }
  }
  // 営業アカウント一覧
  const [accountSaleList, setAccountSaleList] = useState<
    { id: number; account_name: string }[]
  >([]);
  const [accountSaleNameList, setAccountSaleNameList] = useState([""]);
  async function getSaleAccountSalesList() {
    const fetchData = await getSerchAccountSales();
    if (fetchData === null) {
      setAccountSaleList([]);
    } else if (fetchData) {
      setAccountSaleList(
        fetchData.accountSales as { id: number; account_name: string }[],
      );
      let accountSaleNameList = [""];
      fetchData.accountSales.map(
        (accountSale: { id: number; account_name: string }) => {
          if (!accountSaleNameList.includes(accountSale.account_name)) {
            accountSaleNameList.push(accountSale.account_name);
          }
        },
      );
      setAccountSaleNameList(accountSaleNameList);
    }
  }

  useEffect(() => {
    getHighRankCompanyList();
    getCategoryList();
    getProductList();
    getProductNameListFromHistory();
    getSaleAccountSalesList();
    getSaleCompanysList();
  }, []);

  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: "var(--sp-2, 8px)",
          alignItems: "stretch",
          flex: 1,
          minHeight: 0,
        }}
        data-testid="follow-call-page"
      >
        {(serchOpen || aiChatOpen) && isSmartPhone ? null : (
          <Box
            sx={{
              flex: 1,
              minWidth: 0,
              display: "flex",
              flexDirection: "column",
              maxHeight: "100%",
            }}
          >
            <TableTopBar
              serch={true}
              serchOpen={serchOpen}
              setSerchOpen={handleSetSerchOpen}
              addDataNames={addDataNames}
              addDataName={addDataName}
              setAddDataName={setAddDataName}
              addCSVDataNames={addCSVDataNames}
              addCSVDataName={addCSVDataName}
              setAddCSVDataName={setAddCSVDataName}
              getXLSXDataNames={getXLSXDataNames}
              getXLSXDataName={getXLSXDataName}
              setGetXLSXDataName={setGetXLSXDataName}
              editDatasNames={editDatasNames}
              editDatasName={editDatasName}
              setEditDatasName={setEditDatasName}
              editIDs={[]}
              columnSettingOpen={false}
              openColumnSettingWindow={() => {}}
                  totalCount={totalCount}
              onReload={() => getTableData(false)}
            />
            <ConstTable
              emptyState={
                <EmptyState
                  isSearchActive={Object.keys(serchString).some(
                    (k) => (serchString as any)[k] !== (serchColumn as any)[k],
                  )}
                  onClearSearch={() => {
                    setSerchString(serchColumn);
                    setSerchStringView(serchColumn);
                  }}
                  canAdd={false}
                  onAdd={() => {}}
                  entityLabel="フォローコール"
                />
              }
              getTableData={getTableData}
              tableType={"main"}
              serch={true}
              setSerchOpen={handleSetSerchOpen}
              serchOpen={serchOpen}
                tableColumn={followCallTableColumn}
              dataColumn={[]}
              rows={fetchData}
              displayNumber={displayNumber}
              setDisplayNumber={setDisplayNumber}
              displayNumbers={displayNumbers}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              maxPageNumber={maxPageNumber}
              totalCount={totalCount}
              getDataDetail={() => {}}
              getSubTableName={getSubTableName}
              setGetSubTableName={setGetSubTableName}
              getSubTableDetail={{ name: "", key: {}, dataDetail: null }}
              setGetSubTableDetail={() => {}}
              setGetSubTableAdd={() => {}}
              setGetSubTableEditDirect={() => {}}
              getSubSubTableName={{ name: "", key: {}, subData: [] }}
              setGetSubSubTableName={() => {}}
              getSubSubTableDetail={{ name: "", key: {}, dataDetail: null }}
              setGetSubSubTableDetail={() => {}}
              setGetSubSubTableAdd={() => {}}
              setGetSubSubTableEditDirect={() => {}}
              tableTitle={followCallTableColumn.title}
              switchTableCheckBox={() => {}}
              allCheckFlg={false}
              switchAllTableCheckBox={() => {}}
              editIDs={[]}
              setEditIDs={() => {}}
              setEditDatasName={setEditDatasName}
              setTableOriginalFunc={setTableOriginalFunc}
              sortColumn={sortColumn}
              setSortColumn={setSortColumn}
            />
          </Box>
        )}
        {serchOpen ? (
          <SerchSideBar
            setSerchOpen={handleSetSerchOpen}
            tableColumn={followCallTableColumn}
            dataColumn={[]}
            firstYear={firstYear}
            thisYear={thisYear}
            serchColumn={serchColumn}
            setSerchString={setSerchString}
            companyNameList={[]}
            companyGroupNameList={[]}
            highRankCompanyNameList={highRankCompanyNameList}
            categoryNameList={categoryNameList}
            productNameList={productNameList}
            accountSaleNameList={accountSaleNameList}
            accountStaffNameList={[]}
            serchStringView={serchStringView}
            setSerchStringView={setSerchStringView}
          />
        ) : null}
      </Box>
      <FollowCallStartStopModal
        onModal={
          startStopDataInf.status !== null &&
          startStopDataInf.status !== "loading"
        }
        swCloseModal={() => {
          setStartStopDataInf({ status: null, key: {}, message: "" });
          setTableOriginalFunc({ name: "", key: {} });
        }}
        startStopDataInf={startStopDataInf}
        setStartStopDataInf={setStartStopDataInf}
        startStopData={startStopData}
      />
      <FollowCallModal
        onModal={
          callDataInf.status !== null && callDataInf.status !== "loading"
        }
        swCloseModal={() => {
          setCallDataInf({
            status: null,
            key: {},
            message: "",
            follow_call_status: null,
            follow_call_hope_date: "",
            follow_call_hope_time: "",
            follow_call_memo: "",
          });
          setTableOriginalFunc({
            name: "",
            key: {},
          });
        }}
        callDataInf={callDataInf}
        setCallDataInf={setCallDataInf}
        callData={callData}
      />
      <GetXLSXFollowCallModal
        onModal={getXLSXStatus.status !== "none"}
        swCloseModal={() => {
          // cmd-po_1397: データ系facet退役=resetはstatus/messageのみ
          setGetXLSXStatus({ status: "none", message: "", merge_sheet: false });
          setGetXLSXDataName("");
        }}
        getXLSXStatus={getXLSXStatus}
        setGetXLSXStatus={setGetXLSXStatus}
        getXLSXFunc={getPaymentsXLSX}
        totalCount={totalCount}
      />
    </Box>
  );
}

export default FollowCall;
